<div class="coordination-case-split-container" [ngClass]="{'disabled': !hasAccess()}">
  <div class='d-flex justify-content-between modal-header background-colour'>
    <div class='modal-header-title'>
      {{ 'coordination-case-split-title' | translate }}
    </div>
    <div class='modal-buttons'>
      <div (click)='close()'>
        <img ngSrc='/assets/icons/Close White.svg' alt='Close window' height="30" width="30"/>
      </div>
    </div>
  </div>
  <div [appDisableInput]="caseLockHelperService.isCaseBasicLockTaken || caseStateService.isCaseClosed">
    <div class="caselock-no-events">
      <div class="top-row">
        <div class="container-fluid">
          <div class="row justify-content-end">
            <div class="col-auto ps-3 pe-3">
              <div *ngIf="supplierInvoice?.invoiceNumber">
                <div>{{ 'manage-supplier-invoice-invoice-number' | translate }}</div>
                <span>{{ supplierInvoice?.invoiceNumber }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="coordination-case-split-table-container">
        <table class="primary-table">
          <thead>
          <tr>
            <td class="td-case">{{ 'coordination-case-split-case' | translate }}</td>
            <td class="td-service">
              {{ 'coordination-case-split-service' | translate }}
              <span>
                    <div class="add-item-button" *ngIf="!isApproved()" (click)="itemAdd()">
                      {{ 'economy-supplier-invoice-add-item' | translate }} <img
                      src="/assets/icons/add-new.svg" alt="Add linked case split item"/>
                    </div>
                  </span></td>
            <td class="td-split-service-item">{{ 'coordination-case-split-service-item' | translate }}</td>
            <td class="td-split-document">{{ 'coordination-case-split-document' | translate }}</td>
            <td class="td-split-amount">{{ 'coordination-case-split-amount' | translate }}</td>
            <td class="td-split-invoice-amount">{{ 'coordination-case-split-invoice-amount' | translate }}</td>
            <td class="td-split-remove">
            </td>
          </tr>
          </thead>
          <tbody *ngFor="let entry of iccSplitEntries">
          <tr>
            <td>
              <app-drop-down [items]="linkedCaseOptions"
                             [disabled]="isApproved() || isCreditNote()"
                             [(selectedItemId)]="entry.selectedCaseId"
                             (selectedItemIdChange)="entry.caseChanged()"
              />
            </td>
            <td>
              <app-drop-down-service-order [(selectedItemId)]="entry.item.serviceOrderId"
                                           (selectedItemIdChange)="entry.serviceOrderChanged()"
                                           [shouldDisableSelectionOnInvalidServiceOrders]="false"
                                           [disabled]="isApproved() || isCreditNote()"
                                           [serviceOrders]="entry.serviceOrders"

              />
            </td>
            <td>
              <app-drop-down [items]="entry.serviceItems"
                             [disabled]="isApproved() || isCreditNote()"
                             (selectedItemIdChange)="entry.serviceItemChanged($event)"
                             [(selectedItemId)]="entry.item.serviceItemCode"
              />
            </td>
            <td>
              <app-file-upload [splitItem]="entry.item"
                               [isApproved]="isApproved()"
                               (documentChanged)="entry.documentChanged($event.docId, $event.docName)"
                               [supplierInvoiceId]="supplierInvoice.id"
              />
            </td>
            <td>
              <div class="input-with-currency">
                <div class="input-with-currency-currency">{{ entry.item.splitMoney.currency }}</div>
                <input
                  class="input-height"
                  [(ngModel)]="entry.item.splitMoney.amount"
                  [disabled]="isApproved() || isCreditNote()"
                  currencyMask
                  [options]="currencyMaskOptions"
                  (ngModelChange)="entry.amountChanged()"
                />
              </div>
            </td>
            <td>
              <div class="input-with-currency">
                <div class="input-with-currency-currency">{{ entry.item.splitOriginalInvoiceMoney.currency }}</div>
                <input
                  class="input-height"
                  [(ngModel)]="entry.item.splitOriginalInvoiceMoney.amount"
                  [disabled]="true"
                  currencyMask
                  [options]="currencyMaskOptions"
                />
              </div>
            </td>
            <td [ngClass]="{'delete-button': !isApproved() || !isCreditNote(), 'no-delete-button': isApproved() || isCreditNote() }" (click)="deleteLinkedItem(entry.item)"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row coordination-case-split-footer align-items-end">
        <div class="col col-3 align-self-end">
          <div class="coordination-case-split-footer-box">
            <div class="container-fluid box-table">
              <div class="row">
                <div class="col first-col-fixed">{{ 'coordination-case-split-invoice-amount' | translate }}</div>
                <div class="col second-col-fixed">
                  {{ supplierInvoice?.invoiceAmountExchanged.amount | number: amountFormat }}
                </div>
                <div class="col coordination-case-split-footer-currency">{{ supplierInvoice?.invoiceAmountExchanged.currency }}
                </div>
              </div>
              <div class="row">
                <div class="col first-col-fixed">{{ 'coordination-case-split-line-amount' | translate }}</div>
                <div class="col second-col-fixed">
                  {{ lineTotalDKK | number: amountFormat }}
                </div>
                <div class="col coordination-case-split-footer-currency">{{ supplierInvoice?.invoiceAmountExchanged.currency }}
                </div>
              </div>
              <div class="row">
                <div class="col sum-line"></div>
              </div>
              <div class="row">
                <div class="col first-col-fixed-sum">{{ 'coordination-case-split-amount-markup' | translate }}</div>
                <div [ngClass]="{'typed-amount-differ': !isDKKTotalValid(), 'typed-amount-valid' : isDKKTotalValid()}" class="col second-col-fixed-sum">
                  {{ lineTotalDKK - supplierInvoice?.invoiceAmountExchanged.amount | number: amountFormat }}
                </div>
                <div class="col coordination-case-split-footer-currency">{{ supplierInvoice?.invoiceAmountExchanged.currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-3 align-self-end">
          <div class="coordination-case-split-footer-box">
            <div class="container-fluid box-table">
              <div class="row">
                <div class="col first-col-fixed">{{ 'coordination-case-split-invoice-amount' | translate }}</div>
                <div class="col second-col-fixed">
                  {{ supplierInvoice?.invoiceAmountLocal.amount | number: amountFormat }}
                </div>
                <div class="col coordination-case-split-footer-currency">{{ supplierInvoice?.invoiceAmountLocal.currency }}
                </div>
              </div>
              <div class="row">
                <div class="col first-col-fixed">{{ 'coordination-case-split-line-amount' | translate }}</div>
                <div class="col second-col-fixed">
                  {{ lineTotal | number: amountFormat }}
                </div>
                <div class="col coordination-case-split-footer-currency">{{ supplierInvoice?.invoiceAmountLocal.currency }}
                </div>
              </div>
              <div class="row">
                <div class="col sum-line"></div>
              </div>
              <div class="row">
                <div class="col first-col-fixed-sum">{{ 'coordination-case-split-amount-markup' | translate }}</div>
                <div [ngClass]="{'typed-amount-differ': !isTotalValid(), 'typed-amount-valid' : isTotalValid()}" class="col second-col-fixed-sum">
                  {{ lineTotal - supplierInvoice?.invoiceAmountLocal.amount | number: amountFormat }}
                </div>
                <div class="col coordination-case-split-footer-currency">{{ supplierInvoice?.invoiceAmountLocal.currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-actions">
        <button class="default-button-white" (click)="saveSplit()"
                [disabled]='!hasAccess()'>{{ 'coordination-case-split-save' | translate }}</button>
        <button class="default-button" [ngClass]="{ 'default-button-disabled': isApproved() || !isApprovePossible() || !hasAccess()}"
                [disabled]="isApproved() || !hasAccess() || !isApprovePossible()"
                (click)="approveSplit()">{{ 'coordination-case-split-approve' | translate }}</button>
      </div>
    </div>
  </div>
</div>
